module.exports = __webpack_public_path__ + "img/sticker_10.6cb3fbb2.svg";